import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiDownload } from 'react-icons/fi';
import Swal from 'sweetalert2';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import editIcon from './../../../../../Assets/icons/Un-Checkbox.svg';
import DownloadSVG from './../../../../../Assets/icons/DownloadIconMIS.svg';
import axiosInstance from '../../../../services/api/API';
import ListLogisticsFilters from '../../../Logistics/LogisticsFilter';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import searchIcon from '../../../../../Assets/icons/searchicon.svg';
import Loader from '../../../../customComponents/CustomLoader';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import { showAlert } from '../../../../customComponents/CustomSweetAlert/ShowAlert';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import { buttonStyle, isFormValid } from '../../../../../helpers/common';

import './index.scss';

const ItemList = () => {
  const [itemData, setItemData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [dealerOption, setDealerOptions] = useState([]);
  const [accessoryOptions, setaccessoryOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const [itemCategoryOption, setItemcategoryOptions] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [modelOptions, setModelOptions] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);

  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const [exportModal, setExportModal] = useState(false);

  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchItemList(newPage);
  };

  const handleExportModalOpen = () => {
    setExportModal(true);
    setFormData({});
  };

  const handleExportModalClose = () => {
    setExportModal(false);
    setFormData({});
  };

  const fetchItemDD = async () => {
    try {
      const payload = {
        orderBy: 'item_id desc',
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post(
        '/itemtype/addItemDDL',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.itemtype,
        value: product.itemtype_id,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error('Error fetching product options:', error);
    }
  };

  const fetchItemList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        '/item/list',
        {
          orderBy: 'item_id  desc',
          page,
          pageSize,
          searchText: searchTerm,
          itemType: allfilteredData?.itemType ? allfilteredData?.itemType : '',
          modelId: allfilteredData?.modelId ? allfilteredData?.modelId : '',
          variantId: allfilteredData?.variantId
            ? allfilteredData?.variantId
            : '',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      console.log(totalRecordsData, 'RECORDS');
      setTotalRecords(totalRecordsData);

      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      setItemData(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching item list:', error);
    } finally {
      setLoading(false);
    }
  };
  // modelIdVal
  // useEffect(() => {

  //   const itemTypeVal = formData.itemType
  //   const variantId = formData.variant
  //   const categoryId = formData.category
  //   const modelId = formData.model

  //   if (itemTypeVal
  //     && modelId
  //   ) {
  //     fetchItemOptions(itemTypeVal, variantId, categoryId, modelId)
  //   }

  // }, [formData.itemType, formData.variant, formData.category, formData.model])
  // const fetchItemOptions = async (itemTypeVal, variantId, categoryId, modelId) => {
  //   try {
  //     const token = localStorage.getItem("authToken");
  //     const response = await axiosInstance.post(
  //       "/item/ddlitem",
  //       {
  //         itemtype: itemTypeVal,
  //         variant_id: variantId || 0,
  //         category_id: categoryId || 0,
  //         model_id: modelId
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     const options = response.data.data.data?.map((variant) => ({
  //       label: variant.NAME,
  //       value: variant.ID,
  //     }));
  //     setaccessoryOptions(options);
  //   } catch (error) {
  //     console.error("Error fetching variant options:", error);
  //   }
  // };

  // useEffect(() => {
  //   const modelId = formData.model

  //   if(modelId){
  //     fetchColorOptions(modelId)
  //   }

  // },[formData.model])

  const ITEM_TABLE_HEADERS = [
    // "Sr No.",
    'Item Name',
    'Item Type',
    'Item Code',
    'Image',
    'Purchase Price (₹)',
    'Selling Price (₹)',
    'Item Model',
    'Variant',
    'Item category',
    'Color',
    'Warranty',
    // "HSN Code",
    // "Unit",
    'Status',
    'Action',
  ];

  const itemKeyMapping = {
    // "Sr No.": "Sr No.",
    'Item Name': 'item_name',
    'Item Type': 'itemtype',
    'Item Code': 'item_code',
    Image: 'item_image',
    'Purchase Price (₹)': 'purchase_price',
    'Selling Price (₹)': 'selling_price',
    'Item Model': 'model_name',
    Variant: 'variant_name',
    'Item category': 'part_category_name',
    Color: 'color_name',
    Warranty: 'warranty_name',
    'HSN Code': 'hsncode',
    Unit: 'unit',
    Status: 'status',
    Action: [{ type: 'edit', icon: editIcon, label: 'edit' }],
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : '',
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : '',
      searchText: searchTerm,
      itemType: allfilteredData?.itemType ? allfilteredData?.itemType : '',
      modelId: allfilteredData?.modelId ? allfilteredData?.modelId : '',
      variantId: allfilteredData?.variantId ? allfilteredData?.variantId : '',
      orderBy: '',
    };

    try {
      const response = await axiosInstance.post(
        '/item/item-report-excel',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        },
      );
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'item.csv';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel file:', error);
    }
  };

  const handleEdit = (rowData) => {
    console.log('rowdata>', rowData);
    navigate(`${ROUTES_NAVIGATION.EDITITEM}`, { state: { data: rowData } });
  };
  useEffect(() => {
    if (searchTerm === '') {
      fetchItemList();
    }
  }, [searchTerm]);

  useEffect(() => {
    fetchItemDD();
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: 'model_id desc',
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post('/model/ddlmodel', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));
      console.log(options, 'responseVal');

      setModelOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  useEffect(() => {
    // const colorId = formData.color
    const modelId = filterFormData.model;

    if (modelId) {
      fetchVariantOptions(modelId);
    }
  }, [filterFormData.model]);

  const fetchVariantOptions = async (modelId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        {
          // color_id: colorId,
          model_id: modelId,
          // dealer_id:dealer_id
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  const PhysicalStockTakingInputs = [
    {
      name: 'itemType',
      label: 'Item Type',
      placeholder: 'Enter ',
      type: 'dropdown',
      options: productOptions,
      // required: true,
      gridClass: 'col-lg-3',
      // validation: { required: true },
    },
    {
      // name: "variant",
      name: 'modelId',
      label: 'Model',
      placeholder: '',
      type: 'dropdown',
      options: modelOptions,
      // required: true,
      gridClass: 'col-lg-3',
      // validation: { required: true }
    },
    // {
    //   // name: "variant",
    //   name: "variantId",
    //   label: "Variant",
    //   placeholder: "",
    //   type: "dropdown",
    //   options: variantOptions,
    //   required: true,
    //   gridClass: "col-lg-3",
    //   validation: { required: true },

    // },
  ];

  useEffect(() => {
    const modelId = filterFormData.modelId;
    console.log(modelId, 'MODELiD');

    if (modelId) {
      fetchVariantDropdown(modelId);
    }
  }, [filterFormData.modelId]);

  const fetchVariantDropdown = async (modelId) => {
    try {
      const payload = {
        // orderBy: "model_id desc",
        // page: 0,
        // pageSize: 100,
        modelId: modelId,
      };

      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setVariantOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      itemType: filterFormData.itemType || null,
      modelId: filterFormData.modelId || null,
      variantId: filterFormData.variantId || null,
    });
  };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchItemList();
  };

  useEffect(() => {
    fetchItemList(0, 10);
  }, [filters]);

  const UploadInputs = [
    {
      name: 'uploadDocument',
      label: 'Upload Updated Sheet',
      type: 'file',
      required: true,
      gridClass: 'col-lg-6',
      validation: {
        required: true,
        allowedExtensions: ['csv', 'xlsx'], // Dynamically accepts only CSV & XLSX
        maxSizeMB: 10,
      },
    },
  ];

  const handleFormSubmit = async (formData) => {
    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const formDataToSend = new FormData();
          formDataToSend.append('importFileUpload', formData.uploadDocument);
          // formDataToSend.append("loginUserId", loginUserId);

          const response = await axiosInstance.post(
            `item/importbulk`,
            formDataToSend,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            await showAlert({
              title: 'Success',
              text: 'File Uploaded successfully.',
              icon: 'success',
              confirmButtonText: 'OK',
            });
            setExportModal(false);
          }

          // if (errors.length > 0) {
          //   setExportModal(false); // Close the custom modal

          //   // Show SweetAlert modal with failed record info
          //   await showAlert({
          //     title: "Upload Unsuccessful",
          //     text: `File uploaded with ${success.length} successful rows and ${errors.length} failed rows.`,
          //     icon: "warning",
          //     confirmButtonText: "Export Failed Rows",
          //     showCancelButton: true,
          //     cancelButtonText: "Close"
          //   }).then((result) => {
          //     if (result.isConfirmed) {
          //       // downloadFailedRowsCSV(formData.uploadDocument, errors); // Call your CSV download function
          //     }
          //   });

          // } else {
          //   // fetchActionTaken();
          //   setExportModal(false);
          // }
        } catch (error) {
          // const errorMessage =
          // await showAlert({
          //   title: "Error",
          //   text: "An error occurred while uploading the file.",
          //   icon: "error"
          // });
          console.error(
            'Error submitting uploadform:',
            error?.response?.data?.data,
          );
          const errorMessage = error?.response?.data?.data;
          await showAlert({
            title: 'Error',
            text: errorMessage || 'An error occurred while uploading the file.',
            icon: 'error',
          });
        }
      },
    });

    if (!result.isConfirmed) {
      // Optional: handle if user cancels the confirmation
    }
  };

  const handleExport = async () => {
    // console.log(item.po_details_id, "itemData>>>>>");

    try {
      const allfilteredData = filters;
      const payload = {
        // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
        // state_id: "",
        // services_by: "",
        // servicesValue_Id: "",
        // poStatus: 0,
        // fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : "",
        // toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : "",
        // searchText: searchTerm,
        // itemType: allfilteredData?.itemType ? allfilteredData?.itemType : "",
        // modelId: allfilteredData?.modelId ? allfilteredData?.modelId : "",
        // variantId: allfilteredData?.variantId ? allfilteredData?.variantId : "",
        // orderBy: "",
      };

      const response = await axiosInstance.post(
        `/item/item-report-excel`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        },
      );
      console.log(response, 'resposne');

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', 'sample.csv');

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error('Error accepting order:', error);
      alert('Failed to accept order');
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="OnboardManagamentContainer">
            <div className="OnboardManagamentbuttonContainer">
              <h5>Item Management</h5>
            </div>
            <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
              <div
                className="topleftdataContainer"
                style={{ borderRight: '1px solid lightgrey' }}
              >
                <h5 className="listTopDataValueText">{totalData} </h5>
                <h6>All Product Item</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: '1px solid lightgrey' }}
              >
                <h5 className="listTopDataValueText">{totalActive} </h5>
                <h6>Active Product Item</h6>
              </div>
              <div className="topleftdataContainer">
                <h5 className="listTopDataValueText">{totalInactive} </h5>
                <h6>Inactive Product Item</h6>
              </div>
              <button
                className="addcustomerbutton"
                onClick={() => navigate('/admin/manage-product/item/add-item')}
              >
                Add Item
              </button>
            </div>
          </div>
          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className="listsearchContainer">
                <h5 style={{ paddingTop: '2rem' }}>Item List</h5>
                <div style={{ paddingTop: '2rem' }}>
                  <SearchInput
                    placeholder="Search Item"
                    onSearch={fetchItemList}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    onClick={downloadExcel}
                    className="flte-btnnn"
                    style={{
                      borderRadius: '38px',
                      cursor: 'pointer',
                      marginTop: '2rem',
                    }}
                  >
                    Export
                    <span>
                      <FiDownload
                        className="downloadexcel-misreportsales"
                        style={{ cursor: 'pointer' }}
                        size={22}
                      />
                    </span>
                  </div>
                  {/* <div
                    className="flte-btnnn"
                    onClick={handleExportModalOpen}
                    style={{
                      borderRadius: '38px',
                      cursor: 'pointer',
                      marginTop: '2rem',
                    }}
                  >
                    Import
                    <span></span>
                  </div> */}
                </div>
                <ListLogisticsFilters
                  formConfig={PhysicalStockTakingInputs}
                  formData={filterFormData}
                  setFormData={setFilterFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  handleSearch={handleSearch}
                  handleClear={clearFilter}
                />
              </div>
            </div>
            <CustomTable
              data={itemData}
              headers={ITEM_TABLE_HEADERS}
              keyMapping={itemKeyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords}
            />
          </div>
        </>
      )}

      {exportModal && (
        <div className="customModalOverlay">
          <div className="custom-modal">
            <div className="custom-modal-header">
              <h6 style={{ fontSize: '18px' }}> Upload </h6>
              <button className="close-button" onClick={handleExportModalClose}>
                ×
              </button>
            </div>
            <div className="custom-modal-body">
              <div>
                {/* <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
                          Export Date 
                        </label> */}
                <div>
                  <div className="input-group">
                    {/* <DatePicker
                            ref={(ref) => (datePickerRefs.current["expectedDate"] = ref)}
                            placeholderText="DD/MM/YYYY"
                            selected={expectedDate ? new Date(expectedDate.split("/").reverse().join("-")) : null}
                            onChange={(date) => handleChange("expectedDate", date)}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                             popperPlacement="bottom-start"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            
                          /> */}
                    {/* <span
                            className="input-group-text"
                            onClick={() => openDatePicker("expectedDate")}
                            style={{ cursor: "pointer" }}
                          >
                            <FaCalendarAlt />
                          </span> */}
                  </div>
                </div>
              </div>

              <label
                htmlFor="expectedDate"
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: 'bold',
                  paddingTop: '20px',
                }}
              >
                Download
              </label>

              <div
                style={{ borderRadius: '30px', width: '250px' }}
                className="downloadiconwrapperr"
                onClick={handleExport}
              >
                <a
                  style={{ fontSize: '15px', cursor: 'pointer' }}
                  className="downloadHeading"
                >
                  Download
                </a>
                <img
                  src={downloadIcon}
                  alt="download"
                  className="downloadImg"
                />
              </div>

              {/* <div
                style={{ borderRadius: "30px", width: "250px" }}
                className="downloadiconwrapperr"
              >
                <img
                  src={downloadIcon}
                  alt="download"
                  className="downloadImg"
                />
              </div> */}

              <div>
                <DynamicForm
                  formConfig={UploadInputs}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                />
              </div>
            </div>
            <div className="custom-modal-footer">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(UploadInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  UploadInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => handleFormSubmit(formData)}
              >
                Submit
              </button>
              <button
                className="submit-btn"
                style={{
                  background: 'white',
                  color: '#7BD755',
                  border: '1px solid #7BD755',
                }}
                onClick={handleExportModalClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemList;
